// extracted by mini-css-extract-plugin
export default {"map":"Map_map__x-0YE"};